/** Why an authenticated media request failed, from its HTTP status. */
export type MediaLoadErrorKind = 'missing' | 'unavailable' | 'failed';

export const mediaLoadErrorKind = (status?: number | null): MediaLoadErrorKind => {
  if (status === 404) return 'missing';
  if (status === 502 || status === 503 || status === 504) return 'unavailable';
  return 'failed';
};

export const MEDIA_LOAD_ERROR_TITLE: Record<MediaLoadErrorKind, string> = {
  missing: 'File missing from storage',
  unavailable: 'File storage unavailable',
  failed: "Couldn't load file",
};

/** Error thrown for a non-OK media response; carries the status. */
export class MediaLoadError extends Error {
  readonly status: number;
  readonly kind: MediaLoadErrorKind;

  constructor(status: number) {
    super(`Failed to load media: ${status}`);
    this.name = 'MediaLoadError';
    this.status = status;
    this.kind = mediaLoadErrorKind(status);
  }
}
